import { http, createConfig } from 'wagmi'
import { mainnet, sepolia, polygon, hardhat } from 'wagmi/chains'
import { injected } from 'wagmi/connectors'

// Polygon Amoy testnet definition (not in wagmi by default)
const polygonAmoy = {
    id: 80002,
    name: 'Polygon Amoy',
    nativeCurrency: {
        decimals: 18,
        name: 'POL',
        symbol: 'POL',
    },
    rpcUrls: {
        default: { http: ['https://rpc-amoy.polygon.technology'] },
    },
    blockExplorers: {
        default: { name: 'PolygonScan', url: 'https://amoy.polygonscan.com' },
    },
    testnet: true,
} as const

// Only include Hardhat chain in development when local node is expected
const isDev = import.meta.env.DEV && typeof window !== 'undefined' && window.location.hostname === 'localhost'

export const config = isDev
    ? createConfig({
        chains: [mainnet, polygon, polygonAmoy, sepolia, hardhat],
        connectors: [injected()],
        transports: {
            [mainnet.id]: http(),
            [polygon.id]: http(),
            [polygonAmoy.id]: http(),
            [sepolia.id]: http(),
            [hardhat.id]: http(),
        },
    })
    : createConfig({
        chains: [mainnet, polygon, polygonAmoy, sepolia],
        connectors: [injected()],
        transports: {
            [mainnet.id]: http(),
            [polygon.id]: http(),
            [polygonAmoy.id]: http(),
            [sepolia.id]: http(),
        },
    })

// Export chain IDs for easy reference
export const CHAIN_IDS = {
    MAINNET: 1,
    POLYGON: 137,
    POLYGON_AMOY: 80002,
    SEPOLIA: 11155111,
    HARDHAT: 31337,
} as const

// Betting is only available on Polygon networks
export const BETTING_CHAIN_IDS = [CHAIN_IDS.POLYGON, CHAIN_IDS.POLYGON_AMOY] as const
